angular.module("UI8.components").component("confirmationModal", {
  template: `<div class="modal modal--{{$ctrl.modalName}}">
    <button class="modal__close" ui8-toggle-class="{{$ctrl.modalName}}" ng-click="$ctrl.onDismiss()"></button>
    <div class="modal__container confirmation">
      <h1 class="confirmation__title">{{$ctrl.title}}</h1>
      <p class="confirmation__description">{{$ctrl.description}}</p>
      <div ng-if="$ctrl.showCode" class="field confirmation__code">
        <div class="field__label">Authenticator code</div>
        <input class="field__input" ng-class="{error: $ctrl.localError}" type="text" inputmode="numeric" maxlength="6" placeholder="000000" autocomplete="one-time-code" ng-model="$ctrl.code" ng-keydown="$ctrl.localError = null">
        <div class="field__error" ng-if="$ctrl.localError">{{$ctrl.localError}}</div>
      </div>
      <div class="confirmation__actions">
        <button class="btn" ui8-toggle-class="{{$ctrl.modalName}}" ng-click="$ctrl.onDismiss()">{{$ctrl.cancelText || 'Cancel'}}</button>
        <button class="btn btn--stroke" ng-if="!$ctrl.loading && !$ctrl.showCode" ng-click="$ctrl.handleConfirm()" ui8-toggle-class="{{$ctrl.modalName}}">{{$ctrl.confirmText || 'Confirm'}}</button>
        <button class="btn btn--stroke" ng-if="!$ctrl.loading && $ctrl.showCode" ng-click="$ctrl.handleConfirm()">{{$ctrl.confirmText || 'Confirm'}}</button>
        <div class="loader" ng-if="$ctrl.loading"></div>
      </div>
    </div>
    <div class="modal__backdrop" ui8-toggle-class="{{$ctrl.modalName}}" ng-click="$ctrl.onDismiss()"></div>
  </div>`,

  controller: function () {
    var ctrl = this;

    ctrl.$onChanges = function (changes) {
      if (changes.error && changes.error.currentValue) {
        ctrl.localError = changes.error.currentValue;
      }
    };

    ctrl.onDismiss = function () {
      ctrl.code = "";
      ctrl.localError = null;
    };

    ctrl.handleConfirm = function () {
      if (ctrl.showCode) {
        var code = (ctrl.code || "").trim();
        if (!code || code.length < 6) {
          ctrl.localError = "Please enter a 6-digit authentication code.";
          return;
        }
      }
      ctrl.onConfirm({ code: ctrl.code });
    };
  },

  bindings: {
    modalName: "@",
    title: "@",
    description: "@",
    confirmText: "@",
    cancelText: "@",
    showCode: "<",
    loading: "<",
    error: "<",
    onConfirm: "&",
  },
});
